import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as _ from 'lodash';
import {ConstantsService} from "../../services/constants/constants.service";
import { PermissionsService } from '../../services/permissions/permissions.service';

@Component({
  selector: 'app-perf-metrics',
  templateUrl: './perf-metrics.component.pug',
  styleUrls: ['./perf-metrics.component.scss'],
  standalone: false
})
export class PerfMetricsComponent implements OnInit, OnChanges {

  @Input() perfMetrics: any[] = [];
  perf_metrics: any[] = [];
  ENT_10363_PULSE_RELAUNCH = false;

  constructor(
    private permissionsService: PermissionsService,
  ) {
  }

  ngOnInit(): void {
    this.ENT_10363_PULSE_RELAUNCH = this.permissionsService.isFeatureActivated('ENT-10363-pulse-relaunch');
  }

  chunk(array, size) {
    const chunked_arr: any = [];
    let index = 0;
    while (index < array.length) {
      chunked_arr.push(array.slice(index, size + index));
      index += size;
    }
    return chunked_arr;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.perf_metrics = [];
    // Ensure perfMetrics is an array before processing
    if (this.ENT_10363_PULSE_RELAUNCH && (!Array.isArray(this.perfMetrics) || this.perfMetrics.length === 0)) {
      return;
    }
    this.perfMetrics.sort(function (a, b) {
      return b['value'] - a['value'];
    });
    let chunked_data = _.chunk(this.perfMetrics, 4);

    for (let chunk of chunked_data) {
      let perf_metric: any[] = [];
      for (let d of chunk) {
        let icon_map = ConstantsService.METRICS_ICON_MAP[d['metric']];
        let icon = '', metric = 'Other';
        if (icon_map !== undefined) {
          metric = icon_map['label'];
          if (d['value'] > 3.9999) {
            icon = icon_map['metric_green_icon']
          } else if (d['value'] > 2.9999) {
            icon = icon_map['metric_amber_icon']
          } else {
            icon = icon_map['metric_red_icon']
          }
        }
        perf_metric.push({
          'label': metric,
          'icon': icon,
          'value': Math.round((((9 * (d['value'] - 1)) / 4) + 1) * 10) / 10
        });
      }
      this.perf_metrics.push(perf_metric);
    }
  }


}
